import store from 'utils/store/withMiddleware'

function getAddOnValue(planId: string) {
  const state = store.getState()
  const plan = state.plans[planId]
  const price = plan.durations[0].monthly.premium
  return `${planId}-${plan.planName}-0-0-${price}`
}

export { getAddOnValue }
